module.exports = __webpack_public_path__ + "img/wodedingdan.915bf0c4.png";